import classNames from "classnames/bind";
import styles from "./LiveVideo.module.css";
import PlayerItem from "../../../../../LiveCamera/Camera/StreamCam/PlayerItem";
import React, { useState } from "react";
import streamingClient from "../../../../../../services/streamingClient";

const cx = classNames.bind(styles);

const LiveVideo = ({data}) => {
    const handleScreen = () => {

    }
    
    return (
        <div className={cx('container')}>

            <PlayerItem item={data} handleFullScreen={handleScreen} nfc={[]} screen={0} showOptions={1} />

        </div>
    )
}

export default LiveVideo;